import React from 'react'
import SheetWrapper from '../../../components/SheetWrapper'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import ShareGroupButtons from '../../../components/ShareGroupButtons'

const ShareMobile = ({
  isOpen,
  isAdmin,
  isPayPalUser,
  shareLink,
  setIsShareSheetOpen,
  groupId,
}: {
  isOpen: boolean
  isAdmin: boolean
  isPayPalUser: boolean
  shareLink: string
  setIsShareSheetOpen: React.Dispatch<React.SetStateAction<boolean>>
  groupId: string
}) => {
  const { getContent } = useLocalizedContent()

  return (
    <SheetWrapper
      data-testid="share-sheet"
      isOpen={isOpen}
      title={getContent('share.shareGroup')}
      hideTitle={false}
      onCloseComplete={() => setIsShareSheetOpen(false)}
    >
      <ShareGroupButtons
        shareLink={shareLink}
        isAdmin={isAdmin}
        isPayPalUser={isPayPalUser}
        copySuccessfulMessage={getContent('share.sheetCopyLinkSuccess')}
        groupId={groupId}
      />
    </SheetWrapper>
  )
}

export default ShareMobile
